import { render } from "./ExportModal.vue?vue&type=template&id=23f23580&scoped=true"
import script from "./ExportModal.vue?vue&type=script&lang=js"
export * from "./ExportModal.vue?vue&type=script&lang=js"

import "./ExportModal.vue?vue&type=style&index=0&id=23f23580&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f23580"]])

export default __exports__